var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.mostrarActivo,
                                  expression: "mostrarActivo"
                                }
                              ],
                              attrs: { xs12: "", sm12: "", md12: "" }
                            },
                            [
                              _c("v-switch", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.activo.label,
                                  color: "success",
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.activo.id
                                  ),
                                  "data-vv-name": _vm.formFields.activo.id,
                                  hint: _vm.mensajeEstado,
                                  "persistent-hint": "",
                                  readonly: _vm.isVerDetalle
                                },
                                on: { change: _vm.cambioEstadoSwitch },
                                model: {
                                  value: _vm.formFields.activo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("CampoUnico", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      "required|max:80|" + _vm.uniqueFieldRule,
                                    expression:
                                      "`required|max:80|${uniqueFieldRule}`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombreCalendario.label,
                                  id: _vm.formFields.nombreCalendario.id,
                                  counter: "80",
                                  disabled: _vm.isVerDetalle,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombreCalendario.id
                                  ),
                                  validate: _vm.validarNombreCalendario,
                                  message:
                                    " Ya existe un Calendario con este nombre."
                                },
                                model: {
                                  value: _vm.formFields.nombreCalendario.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombreCalendario,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.nombreCalendario.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Frecuencia" } },
                        [
                          _vm._t("prependFrecuencia"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md12: "", lg12: "" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: {
                                    disabled: _vm.isVerDetalle,
                                    row: ""
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleFrecuenciaSeleccionada()
                                    }
                                  },
                                  model: {
                                    value:
                                      _vm.formFields.frecuenciaSeleccionada
                                        .value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.frecuenciaSeleccionada,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formFields.frecuenciaSeleccionada.value"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "Diaria", value: 0 }
                                  }),
                                  _c("v-radio", {
                                    attrs: { label: "Semanal", value: 1 }
                                  }),
                                  _c("v-radio", {
                                    attrs: { label: "Mensual", value: 2 }
                                  }),
                                  _c("v-radio", {
                                    attrs: { label: "Anual", value: 3 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-layout",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.formFields.frecuenciaSeleccionada
                                      .value === 0,
                                  expression:
                                    "formFields.frecuenciaSeleccionada.value === 0"
                                }
                              ],
                              attrs: { wrap: "" }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md6: "" } },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      staticClass: "radio-group-full-width",
                                      attrs: {
                                        disabled: _vm.isVerDetalle,
                                        column: "",
                                        "hide-details": ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.diariaCantidadDiasRadio
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields
                                              .diariaCantidadDiasRadio,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.diariaCantidadDiasRadio.value"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { "align-center": "" } },
                                        [
                                          _c("v-radio", {
                                            staticClass: "marginRadio",
                                            attrs: { value: 0 }
                                          }),
                                          _vm._v(
                                            "Repetir\n                    Cada:  \n                    "
                                          ),
                                          _c("v-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  rules: {
                                                    required:
                                                      _vm.formFields
                                                        .diariaCantidadDiasRadio
                                                        .value === 0 &&
                                                      !_vm.isVerDetalle &&
                                                      _vm.formFields
                                                        .frecuenciaSeleccionada
                                                        .value === 0
                                                  }
                                                },
                                                expression:
                                                  "{\n                        rules: {\n                          required:\n                            formFields.diariaCantidadDiasRadio.value === 0 &&\n                            !isVerDetalle &&\n                            formFields.frecuenciaSeleccionada.value === 0,\n                        },\n                      }"
                                              }
                                            ],
                                            attrs: {
                                              label:
                                                _vm.formFields.diariaNumDias
                                                  .label,
                                              "error-messages": _vm.errors.collect(
                                                _vm.formFields.diariaNumDias.id
                                              ),
                                              "data-vv-name":
                                                _vm.formFields.diariaNumDias.id,
                                              required: "",
                                              disabled:
                                                _vm.isVerDetalle ||
                                                _vm.formFields
                                                  .diariaCantidadDiasRadio
                                                  .value == 1,
                                              items: _vm.diasMes
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.diariaNumDias
                                                  .value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.diariaNumDias,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.diariaNumDias.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-layout",
                                        { attrs: { "align-center": "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label:
                                                "Todos los días laborales de la semana.",
                                              value: 1
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-layout",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.formFields.frecuenciaSeleccionada
                                      .value === 1,
                                  expression:
                                    "formFields.frecuenciaSeleccionada.value === 1"
                                }
                              ],
                              attrs: { wrap: "" }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md6: "" } },
                                [
                                  _c("v-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          rules: {
                                            required:
                                              !_vm.isVerDetalle &&
                                              _vm.formFields
                                                .frecuenciaSeleccionada
                                                .value === 1
                                          }
                                        },
                                        expression:
                                          "{\n                    rules: {\n                      required:\n                        !isVerDetalle &&\n                        formFields.frecuenciaSeleccionada.value === 1,\n                    },\n                  }"
                                      }
                                    ],
                                    attrs: {
                                      label:
                                        _vm.formFields.semanalCantidadSemanas
                                          .label,
                                      required: "",
                                      disabled: _vm.isVerDetalle,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.semanalCantidadSemanas.id
                                      ),
                                      "data-vv-name":
                                        _vm.formFields.semanalCantidadSemanas
                                          .id,
                                      items: _vm.semanasAnio
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.semanalCantidadSemanas
                                          .value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.semanalCantidadSemanas,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.semanalCantidadSemanas.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("v-flex", {
                                attrs: { xs12: "", sm12: "", md6: "" }
                              }),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md1: "" } },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: "Lunes",
                                      value: 1,
                                      disabled: _vm.isVerDetalle
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.semanalDiasSemana.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.semanalDiasSemana,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.semanalDiasSemana.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md1: "" } },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: "Martes",
                                      value: 2,
                                      disabled: _vm.isVerDetalle
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.semanalDiasSemana.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.semanalDiasSemana,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.semanalDiasSemana.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md1: "" } },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: "Miércoles",
                                      value: 3,
                                      disabled: _vm.isVerDetalle
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.semanalDiasSemana.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.semanalDiasSemana,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.semanalDiasSemana.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "marginJueves",
                                  attrs: { xs12: "", sm12: "", md1: "" }
                                },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: "Jueves",
                                      value: 4,
                                      disabled: _vm.isVerDetalle
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.semanalDiasSemana.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.semanalDiasSemana,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.semanalDiasSemana.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md1: "" } },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: "Viernes",
                                      value: 5,
                                      disabled: _vm.isVerDetalle
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.semanalDiasSemana.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.semanalDiasSemana,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.semanalDiasSemana.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md1: "" } },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: "Sábado",
                                      value: 6,
                                      disabled: _vm.isVerDetalle
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.semanalDiasSemana.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.semanalDiasSemana,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.semanalDiasSemana.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md1: "" } },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: "Domingo",
                                      value: 7,
                                      disabled: _vm.isVerDetalle
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.semanalDiasSemana.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.semanalDiasSemana,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.semanalDiasSemana.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-layout",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.formFields.frecuenciaSeleccionada
                                      .value === 2,
                                  expression:
                                    "formFields.frecuenciaSeleccionada.value === 2"
                                }
                              ],
                              attrs: { wrap: "" }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md9: "" } },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      staticClass: "radio-group-full-width",
                                      attrs: {
                                        disabled: _vm.isVerDetalle,
                                        column: "",
                                        "hide-details": ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.mensualRadio.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.mensualRadio,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.mensualRadio.value"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { "align-center": "" } },
                                        [
                                          _c("v-radio", {
                                            staticClass: "marginRadio",
                                            attrs: { value: 0 }
                                          }),
                                          _vm._v("El  \n                    "),
                                          _c("v-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  rules: {
                                                    required:
                                                      _vm.formFields
                                                        .frecuenciaSeleccionada
                                                        .value === 2 &&
                                                      _vm.formFields
                                                        .mensualRadio.value ===
                                                        0 &&
                                                      !_vm.isVerDetalle
                                                  }
                                                },
                                                expression:
                                                  "{\n                        rules: {\n                          required:\n                            formFields.frecuenciaSeleccionada.value === 2 &&\n                            formFields.mensualRadio.value === 0 &&\n                            !isVerDetalle,\n                        },\n                      }"
                                              }
                                            ],
                                            attrs: {
                                              label:
                                                _vm.formFields.mensualDiaMes
                                                  .label,
                                              required: "",
                                              disabled:
                                                _vm.isVerDetalle ||
                                                _vm.formFields.mensualRadio
                                                  .value == 1,
                                              "error-messages": _vm.errors.collect(
                                                _vm.formFields.mensualDiaMes.id
                                              ),
                                              "data-vv-name":
                                                _vm.formFields.mensualDiaMes.id,
                                              items: _vm.diasMes
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.mensualDiaMes
                                                  .value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.mensualDiaMes,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.mensualDiaMes.value"
                                            }
                                          }),
                                          _vm._v(
                                            "  cada\n                    "
                                          ),
                                          _c("v-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  rules: {
                                                    required:
                                                      !_vm.isVerDetalle &&
                                                      _vm.formFields
                                                        .frecuenciaSeleccionada
                                                        .value === 2 &&
                                                      _vm.formFields
                                                        .mensualRadio.value ===
                                                        0
                                                  }
                                                },
                                                expression:
                                                  "{\n                        rules: {\n                          required:\n                            !isVerDetalle &&\n                            formFields.frecuenciaSeleccionada.value === 2 &&\n                            formFields.mensualRadio.value === 0,\n                        },\n                      }"
                                              }
                                            ],
                                            staticClass: "margenIzquierdo",
                                            attrs: {
                                              label:
                                                _vm.formFields.mensualCantMeses
                                                  .label,
                                              required: "",
                                              disabled:
                                                _vm.isVerDetalle ||
                                                _vm.formFields.mensualRadio
                                                  .value == 1,
                                              "error-messages": _vm.errors.collect(
                                                _vm.formFields.mensualCantMeses
                                                  .id
                                              ),
                                              "data-vv-name":
                                                _vm.formFields.mensualCantMeses
                                                  .id,
                                              items: _vm.mesesAnio
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.mensualCantMeses
                                                  .value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields
                                                    .mensualCantMeses,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.mensualCantMeses.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-layout",
                                        { attrs: { "align-center": "" } },
                                        [
                                          _c("v-radio", {
                                            staticClass: "marginRadio",
                                            attrs: { value: 1 }
                                          }),
                                          _vm._v("El  \n                    "),
                                          _c("v-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  rules: {
                                                    required:
                                                      !_vm.isVerDetalle &&
                                                      _vm.formFields
                                                        .frecuenciaSeleccionada
                                                        .value === 2 &&
                                                      _vm.formFields
                                                        .mensualRadio.value ===
                                                        1
                                                  }
                                                },
                                                expression:
                                                  "{\n                        rules: {\n                          required:\n                            !isVerDetalle &&\n                            formFields.frecuenciaSeleccionada.value === 2 &&\n                            formFields.mensualRadio.value === 1,\n                        },\n                      }"
                                              }
                                            ],
                                            attrs: {
                                              label:
                                                _vm.formFields
                                                  .mensualDiaSemanaNum.label,
                                              items: _vm.diaSemanaPosicion,
                                              "item-text": "posicion",
                                              "item-value": "id",
                                              required: "",
                                              disabled:
                                                _vm.isVerDetalle ||
                                                _vm.formFields.mensualRadio
                                                  .value == 0,
                                              "error-messages": _vm.errors.collect(
                                                _vm.formFields
                                                  .mensualDiaSemanaNum.id
                                              ),
                                              "data-vv-name":
                                                _vm.formFields
                                                  .mensualDiaSemanaNum.id
                                            },
                                            model: {
                                              value:
                                                _vm.formFields
                                                  .mensualDiaSemanaNum.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields
                                                    .mensualDiaSemanaNum,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.mensualDiaSemanaNum.value"
                                            }
                                          }),
                                          _c("v-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  rules: {
                                                    required:
                                                      !_vm.isVerDetalle &&
                                                      _vm.formFields
                                                        .frecuenciaSeleccionada
                                                        .value === 2 &&
                                                      _vm.formFields
                                                        .mensualRadio.value ===
                                                        1
                                                  }
                                                },
                                                expression:
                                                  "{\n                        rules: {\n                          required:\n                            !isVerDetalle &&\n                            formFields.frecuenciaSeleccionada.value === 2 &&\n                            formFields.mensualRadio.value === 1,\n                        },\n                      }"
                                              }
                                            ],
                                            staticClass: "margenIzquierdo",
                                            attrs: {
                                              label:
                                                _vm.formFields
                                                  .mensualDiaSemanaNombre.label,
                                              items: _vm.diaSemanaNombre,
                                              "item-text": "nombre",
                                              "item-value": "id",
                                              required: "",
                                              disabled:
                                                _vm.isVerDetalle ||
                                                _vm.formFields.mensualRadio
                                                  .value == 0,
                                              "error-messages": _vm.errors.collect(
                                                _vm.formFields
                                                  .mensualDiaSemanaNombre.id
                                              ),
                                              "data-vv-name":
                                                _vm.formFields
                                                  .mensualDiaSemanaNombre.id
                                            },
                                            model: {
                                              value:
                                                _vm.formFields
                                                  .mensualDiaSemanaNombre.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields
                                                    .mensualDiaSemanaNombre,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.mensualDiaSemanaNombre.value"
                                            }
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "margenIzquierdo" },
                                            [_vm._v("  cada")]
                                          ),
                                          _c("v-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  rules: {
                                                    required:
                                                      !_vm.isVerDetalle &&
                                                      _vm.formFields
                                                        .frecuenciaSeleccionada
                                                        .value === 2 &&
                                                      _vm.formFields
                                                        .mensualRadio.value ===
                                                        1
                                                  }
                                                },
                                                expression:
                                                  "{\n                        rules: {\n                          required:\n                            !isVerDetalle &&\n                            formFields.frecuenciaSeleccionada.value === 2 &&\n                            formFields.mensualRadio.value === 1,\n                        },\n                      }"
                                              }
                                            ],
                                            staticClass: "margenIzquierdo",
                                            attrs: {
                                              label:
                                                _vm.formFields.mensualNumMeses
                                                  .label,
                                              required: "",
                                              disabled:
                                                _vm.isVerDetalle ||
                                                _vm.formFields.mensualRadio
                                                  .value == 0,
                                              items: _vm.mesesAnio,
                                              "error-messages": _vm.errors.collect(
                                                _vm.formFields.mensualNumMeses
                                                  .id
                                              ),
                                              "data-vv-name":
                                                _vm.formFields.mensualNumMeses
                                                  .id
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.mensualNumMeses
                                                  .value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields
                                                    .mensualNumMeses,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.mensualNumMeses.value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-layout",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.formFields.frecuenciaSeleccionada
                                      .value === 3,
                                  expression:
                                    "formFields.frecuenciaSeleccionada.value === 3"
                                }
                              ],
                              attrs: { wrap: "" }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md6: "" } },
                                [
                                  _c("v-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          rules: {
                                            required:
                                              !_vm.isVerDetalle &&
                                              _vm.formFields
                                                .frecuenciaSeleccionada
                                                .value === 3
                                          }
                                        },
                                        expression:
                                          "{\n                    rules: {\n                      required:\n                        !isVerDetalle &&\n                        formFields.frecuenciaSeleccionada.value === 3,\n                    },\n                  }"
                                      }
                                    ],
                                    attrs: {
                                      label:
                                        _vm.formFields.anualCantAnios.label,
                                      required: "",
                                      disabled: _vm.isVerDetalle,
                                      items: _vm.anios,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.anualCantAnios.id
                                      ),
                                      "data-vv-name":
                                        _vm.formFields.anualCantAnios.id
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.anualCantAnios.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.anualCantAnios,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.anualCantAnios.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("v-flex", {
                                attrs: { xs12: "", sm12: "", md6: "" }
                              }),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md6: "" } },
                                [
                                  _c("v-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          rules: {
                                            required:
                                              !_vm.isVerDetalle &&
                                              _vm.formFields
                                                .frecuenciaSeleccionada
                                                .value === 3
                                          }
                                        },
                                        expression:
                                          "{\n                    rules: {\n                      required:\n                        !isVerDetalle &&\n                        formFields.frecuenciaSeleccionada.value === 3,\n                    },\n                  }"
                                      }
                                    ],
                                    attrs: {
                                      label:
                                        _vm.formFields.anualNumDiaMes.label,
                                      required: "",
                                      disabled: _vm.isVerDetalle,
                                      items: _vm.diasMes,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.anualNumDiaMes.id
                                      ),
                                      "data-vv-name":
                                        _vm.formFields.anualNumDiaMes.id
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.anualNumDiaMes.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.anualNumDiaMes,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.anualNumDiaMes.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md6: "" } },
                                [
                                  _c("v-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          rules: {
                                            required:
                                              !_vm.isVerDetalle &&
                                              _vm.formFields
                                                .frecuenciaSeleccionada
                                                .value === 3
                                          }
                                        },
                                        expression:
                                          "{\n                    rules: {\n                      required:\n                        !isVerDetalle &&\n                        formFields.frecuenciaSeleccionada.value === 3,\n                    },\n                  }"
                                      }
                                    ],
                                    attrs: {
                                      label:
                                        _vm.formFields.anualCantMeses.label,
                                      required: "",
                                      disabled: _vm.isVerDetalle,
                                      items: _vm.mesesAnio,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.anualCantMeses.id
                                      ),
                                      "data-vv-name":
                                        _vm.formFields.anualCantMeses.id
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.anualCantMeses.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.anualCantMeses,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.anualCantMeses.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c("br"),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Intervalo de Repetición" } },
                        [
                          _vm._t("prependIntervalo"),
                          _c(
                            "v-flex",
                            {
                              staticClass: "marginFlex",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required: !_vm.isVerDetalle
                                      }
                                    },
                                    expression:
                                      "{\n                  rules: {\n                    required: !isVerDetalle,\n                  },\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.fechaInicio.label,
                                  id: _vm.formFields.fechaInicio.id,
                                  disabled: _vm.isVerDetalle,
                                  min: _vm.fechaMinimaInicio.format(
                                    "YYYY-MM-DD"
                                  ),
                                  max:
                                    _vm.fechaMaximaInicio != null
                                      ? _vm.fechaMaximaInicio.format(
                                          "YYYY-MM-DD"
                                        )
                                      : "",
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaInicio.id
                                  ),
                                  "data-vv-name": _vm.formFields.fechaInicio.id,
                                  format: "dddd,DD/MM/YYYY"
                                },
                                model: {
                                  value: _vm.formFields.fechaInicio.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaInicio,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaInicio.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "radio-group-full-width",
                                  attrs: {
                                    disabled: _vm.isVerDetalle,
                                    column: "",
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: _vm.formFields.radioFechaFin.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.radioFechaFin,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formFields.radioFechaFin.value"
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { "align-center": "" } },
                                    [
                                      _c("v-radio", {
                                        staticClass: "marginRadio",
                                        attrs: { value: 0 }
                                      }),
                                      _c("DatePicker", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              rules: {
                                                required:
                                                  !_vm.isVerDetalle &&
                                                  _vm.formFields.radioFechaFin
                                                    .value === 0
                                              }
                                            },
                                            expression:
                                              "{\n                      rules: {\n                        required:\n                          !isVerDetalle &&\n                          formFields.radioFechaFin.value === 0,\n                      },\n                    }"
                                          }
                                        ],
                                        staticClass: "marginDatePicker",
                                        attrs: {
                                          label: _vm.formFields.fechaFin.label,
                                          id: _vm.formFields.fechaFin.id,
                                          disabled:
                                            _vm.isVerDetalle ||
                                            _vm.formFields.radioFechaFin
                                              .value !== 0,
                                          "error-messages": _vm.errors.collect(
                                            _vm.formFields.fechaFin.id
                                          ),
                                          "data-vv-name":
                                            _vm.formFields.fechaFin.id,
                                          min: _vm.fechaMinimaFin.format(
                                            "YYYY-MM-DD"
                                          ),
                                          format: "dddd,DD/MM/YYYY"
                                        },
                                        model: {
                                          value: _vm.formFields.fechaFin.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.fechaFin,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.fechaFin.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-layout",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.formFields
                                              .frecuenciaSeleccionada.value !==
                                            3,
                                          expression:
                                            "formFields.frecuenciaSeleccionada.value !== 3"
                                        }
                                      ],
                                      staticClass: "paddingTop",
                                      attrs: { "align-center": "" }
                                    },
                                    [
                                      _c("v-radio", {
                                        staticClass: "marginRadio",
                                        attrs: {
                                          value: 1,
                                          readonly:
                                            _vm.formFields
                                              .frecuenciaSeleccionada.value ===
                                            3
                                        }
                                      }),
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              rules: {
                                                required:
                                                  !_vm.isVerDetalle &&
                                                  _vm.formFields.radioFechaFin
                                                    .value == 1,
                                                numeric: true,
                                                min_value: 1,
                                                max_value: 999
                                              }
                                            },
                                            expression:
                                              "{\n                      rules: {\n                        required:\n                          !isVerDetalle &&\n                          formFields.radioFechaFin.value == 1,\n                        numeric: true,\n                        min_value: 1,\n                        max_value: 999,\n                      },\n                    }"
                                          }
                                        ],
                                        staticClass: "paddingText",
                                        attrs: {
                                          disabled:
                                            _vm.isVerDetalle ||
                                            _vm.formFields.radioFechaFin
                                              .value !== 1,
                                          label:
                                            _vm.formFields.numRepeticiones
                                              .label,
                                          "error-messages": _vm.errors.collect(
                                            _vm.formFields.numRepeticiones.id
                                          ),
                                          "data-vv-name":
                                            _vm.formFields.numRepeticiones.id
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.numRepeticiones
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.numRepeticiones,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.numRepeticiones.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "paddingTop",
                                      attrs: { "align-center": "" }
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: "Sin fecha de finalización",
                                          value: 2
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }